import { ErrorBoundary } from '@sentry/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedRadarTemplateAtom, setRadarTemplateDeleteAtom } from '@/atoms/radar';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';
import { hasFullAccessPermissions } from '@/utils/userConfigs';

const RadarTemplateDeleteMenuOptionBase = ({ onClick, isDisabled }: { onClick?: () => void; isDisabled?: boolean }) => {
  const { t } = useTranslation('general');

  return <MenuItemWithIcon icon="Delete" onClick={onClick} text={t('delete')} disabled={isDisabled} />;
};

const RadarTemplateDeleteMenuOptionWithData = () => {
  const selectedTemplate = useAtomValue(selectedRadarTemplateAtom);
  const setRadarTemplateDelete = useSetAtom(setRadarTemplateDeleteAtom);

  if (!selectedTemplate) {
    throw new Error('Unable to find selected radar template');
  }

  return (
    <RadarTemplateDeleteMenuOptionBase
      isDisabled={!hasFullAccessPermissions(selectedTemplate.permission)}
      onClick={() => setRadarTemplateDelete(selectedTemplate.configId)}
    />
  );
};

export const RadarTemplateDeleteMenuOption = () => (
  <ErrorBoundary fallback={<RadarTemplateDeleteMenuOptionBase isDisabled />}>
    <Suspense fallback={<RadarTemplateDeleteMenuOptionBase isDisabled />}>
      <RadarTemplateDeleteMenuOptionWithData />
    </Suspense>
  </ErrorBoundary>
);
